/* Keep WhatStar's visible reviews on the main Product; cards retain ratings without extra entities. */
(() => {
  if (window.hatchillReviewSchemaReady) return;
  window.hatchillReviewSchemaReady = true;
  const selector = '#whatstar-reviews [data-wr-widget="product-reviews"]';
  const widgetSelector = '[data-wr-widget="product-reviews"], [data-wr-widget="product-card-rating"], [data-wr-widget="rating-badge"]';
  const providers = new WeakMap();
  const clean = node => (node?.textContent || '').replace(/\s+/g, ' ').trim();
  const parse = node => {
    try { return JSON.parse(node.textContent); } catch { return null; }
  };
  function removeProviderProducts(widget) {
    for (const script of widget.querySelectorAll('script[type="application/ld+json"]')) {
      const data = parse(script);
      if (data?.['@type'] === 'Product' && data.aggregateRating && !data['@id']) script.remove();
    }
  }
  function sync(widget, loaded) {
    if (!widget?.matches(widgetSelector)) return;
    const primary = document.querySelector('script[data-hatchill-product-schema]');
    if (widget.matches('[data-wr-widget="product-card-rating"]') || !primary || !widget.matches(selector) || widget.dataset.wrProductId !== primary.dataset.productId) {
      removeProviderProducts(widget);
      return;
    }
    const product = parse(primary);
    if (product?.['@type'] !== 'Product') return;
    delete product.aggregateRating;
    delete product.review;
    const scripts = [...widget.querySelectorAll('script[type="application/ld+json"]')];
    if (!loaded) providers.delete(widget);
    const provider = scripts.map(parse).find(data => data?.['@type'] === 'Product' && data.aggregateRating && !data['@id']) || (loaded && providers.get(widget));
    if (provider && loaded) providers.set(widget, provider);
    const score = widget.querySelector('.wr-widget__proof-score')?.getAttribute('aria-label');
    const visibleScore = /^(\d+(?:\.\d+)?) out of 5 stars from (\d+) reviews$/.exec(score || '');
    const empty=loaded&&widget.dataset.wrState==='loaded'&&visibleScore&&Number(visibleScore[2])===0;
    widget.dataset.hcEmptyReviews=String(Boolean(empty));
    if(empty){
      const ar=document.documentElement?.lang?.startsWith('ar'),title=widget.querySelector('.wr-widget__empty strong'),copy=widget.querySelector('.wr-widget__empty p');
      if(title)title.textContent=ar?'لا توجد تقييمات بعد':'No reviews yet';
      if(copy)copy.textContent=ar?'تظهر هنا تقييمات العملاء بعد الشراء.':'Customer feedback will appear here after purchase.';
    }
    const rating = Number(provider?.aggregateRating?.ratingValue);
    const count = Number(provider?.aggregateRating?.reviewCount);
    if (loaded && widget.dataset.wrState === 'loaded' && widget.getClientRects().length && !widget.closest('[hidden], [aria-hidden="true"]') &&
        visibleScore && rating >= 1 && rating <= 5 && Number.isInteger(count) && count > 0 &&
        Number(visibleScore[1]) === rating && Number(visibleScore[2]) === count) {
      product.aggregateRating = { '@type': 'AggregateRating', ratingValue: rating, reviewCount: count, bestRating: 5, worstRating: 1 };
      const reviews = [...widget.querySelectorAll('.wr-widget__reviews .wr-widget__card')].filter(card => card.getClientRects().length).map(card => {
        const author = clean(card.querySelector('.wr-widget__author'));
        const body = clean(card.querySelector('.wr-widget__review-copy'));
        const title = clean(card.querySelector('.wr-widget__review-title'));
        const stars = /^(\d+(?:\.\d+)?) out of 5 stars$/.exec(card.querySelector('.wr-widget__stars')?.getAttribute('aria-label') || '');
        const value = Number(stars?.[1]);
        if (!author || !body || !(value >= 1 && value <= 5)) return null;
        return { '@type': 'Review', author: { '@type': 'Person', name: author }, reviewBody: body,
          ...(title ? { name: title } : {}), reviewRating: { '@type': 'Rating', ratingValue: value, bestRating: 5, worstRating: 1 } };
      }).filter(Boolean);
      if (reviews.length && reviews.length <= count) product.review = reviews;
    }
    primary.textContent = JSON.stringify(product).replace(/</g, '\\u003c');
    // Only replace the app's unlinked review entity inside this product's widget.
    removeProviderProducts(widget);
  }
  for (const event of ['wr:ready', 'wr:loaded', 'wr:error']) document.addEventListener(event, e => sync(e.target, event === 'wr:loaded'));
  const init = () => document.querySelectorAll(widgetSelector).forEach(widget => sync(widget, true));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
